import React from 'react';
import { cn } from '@lqa-frontend/ui-system';
import type { ITableToolbarProps } from './types';

function TableToolbar({
	children,
	className,
	isDisabled = false,
}: Readonly<ITableToolbarProps>) {
	return (
		<div
			className={cn(
				'relative z-20 flex flex-wrap items-center justify-between gap-12 bg-base-1 px-10 py-10 border-b border-divider',
				// Kept in the layout while the table loads, so nothing moves;
				// inert so a filter cannot be changed against stale rows.
				isDisabled && 'pointer-events-none opacity-60',
				className
			)}
			aria-disabled={isDisabled || undefined}
			data-slot="table-toolbar"
			data-testid="table-toolbar"
		>
			{children}
		</div>
	);
}

export { TableToolbar };
